import { Api } from '../../services/http/Api';
import { Product } from '../../types/product/Product';

export type ProductData = {
  rows: number;
  data: Product[];
  page: number;
  pagesize: number;
};

export class ProductDataSource {
  async QuerySalesProducts({
    searchText,
    categoryIds = [],
    subCategoryIds = [],
    segmentIds = [],
    page = 0,
    pageSize = 12,
    sapCodePrefix,
    catalogSegmentIds = [],
  }: {
    searchText?: string;
    categoryIds?: Array<number | string>;
    subCategoryIds?: Array<number | string>;
    segmentIds?: Array<number | string>;
    page?: number;
    pageSize?: number;
    sapCodePrefix?: string;
    catalogSegmentIds?: Array<number | string>;
  }) {
    const params = [`page=${page}`, `pagesize=${pageSize}`];

    if (sapCodePrefix?.trim()) {
      params.push(`sapCodePrefix=${encodeURIComponent(sapCodePrefix.trim())}`);
    }

    if (searchText?.trim()) {
      params.push(`searchText=${encodeURIComponent(searchText.trim())}`);
    }
    if (categoryIds.length > 0) {
      params.push(`categoryIds=${encodeURIComponent(categoryIds.join(','))}`);
    }
    if (subCategoryIds.length > 0) {
      params.push(
        `subCategoryIds=${encodeURIComponent(subCategoryIds.join(','))}`
      );
    }
    if (segmentIds.length > 0) {
      params.push(`segmentIds=${encodeURIComponent(segmentIds.join(','))}`);
    }
    if (catalogSegmentIds.length > 0) {
      params.push(
        `catalogSegmentIds=${encodeURIComponent(catalogSegmentIds.join(','))}`
      );
    }
    return (await new Api().fetch(
      `/product?${params.join('&')}`
    )) as ProductData;
  }

  async QuerySalesCatalogFilters({
    sapCodePrefix,
    catalogSegmentIds = [],
  }: {
    sapCodePrefix?: string;
    catalogSegmentIds?: Array<number | string>;
  } = {}) {
    const params = [];

    if (sapCodePrefix?.trim()) {
      params.push(`sapCodePrefix=${encodeURIComponent(sapCodePrefix.trim())}`);
    }

    if (catalogSegmentIds.length > 0) {
      params.push(
        `catalogSegmentIds=${encodeURIComponent(catalogSegmentIds.join(','))}`
      );
    }

    const query = params.length > 0 ? `?${params.join('&')}` : '';
    return await new Api().fetch(`/product/catalogFilters${query}`);
  }

  async QueryProducts(
    productId: any,
    sapCode: any,
    branch: any,
    categoryId: any,
    subCategoryId: any,
    segmentId: any,
    layout: any,
    type: any,
    searchText: any,
    page: any,
    pageSize: any,
    segmentDescriptions: string[] = []
  ) {
    let url = `/product?`;
    const params = [];
    if (productId && productId !== '') {
      params.push('productId=' + productId);
    }
    if (sapCode && sapCode !== '') {
      params.push('sapCode=' + sapCode);
    }
    if (branch && branch !== '') {
      params.push('branch=' + branch);
    }
    if (categoryId && categoryId !== '') {
      params.push('categoryId=' + categoryId);
    }
    if (subCategoryId && subCategoryId !== '') {
      params.push('subCategoryId=' + subCategoryId);
    }
    if (segmentId && segmentId !== '') {
      params.push('segmentId=' + segmentId);
    }
    if (layout && layout !== '') {
      params.push('layout=' + layout);
    }
    if (type && type !== '') {
      params.push('type=' + type);
    }
    if (segmentDescriptions.length > 0) {
      params.push(
        'segmentDescriptions=' +
          encodeURIComponent(segmentDescriptions.join('|'))
      );
    }
    if (searchText && searchText !== '') {
      params.push('searchText=' + searchText);
    }
    if (page && page !== '') {
      params.push('page=' + page);
    }
    if (pageSize && pageSize !== '') {
      params.push('pagesize=' + pageSize);
    }
    url = url + params.join('&');
    const result = await new Api().fetch(url);
    return result;
  }
}
